import Navbar from "../../../component/navbar";
import Footer from "../../../component/footer";
import ReactOwlCarousel from "react-owl-carousel";
import { Link, useNavigate } from "react-router-dom";
import Fancybox from "../../../component/Fancybox";
import { Carousel } from "flowbite";
export default function Flex() {
  const navigate = useNavigate();
  // ประกาศ
  const menu_one = () => {
    const options = {
      margin: 10,
      responsiveClass: true,
      dots: false,
      autoplayHoverPause: true,
      navText: [
        '<span class="custom-nav-btn"><i class="fa-solid fa-backward"></i> </span>',
        '<span class="custom-nav-btn"> <i class="fa-solid fa-forward"></i></span>',
      ],

      responsive: {
        0: { items: 1, nav: true },
        600: { items: 2, nav: true },
        1000: { items: 3, nav: true },
        1200: { items: 2, nav: true },
      },
    };

    return (
      <>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div
            onClick={() => navigate("/pages/academic/flex/announce/1")}
            className="bg-[#9e76b4]/20 w-full hover:bg-[#9e76b4]/60 rounded-lg cursor-pointer transition-all duration-500 group overflow-hidden shadow-lg"
          >
            <div className="flex flex-col justify-center items-center h-20 border-b-4 border-[#9e76b4] px-5 space-y-1">
              <span className="text-red-500 font-[600] md:text-2xl text-lg">ประกาศ</span>
              <span className="text-[#9e76b4]  group-hover:text-white font-[600] md:text-2xl text-lg">
                หลักเกณฑ์ และวิธีการเบิกสวัสดิการ
              </span>
            </div>
          </div>
          <div
            onClick={() =>
              window.open("https://flexbenefits.mis.cmu.ac.th/", "_blank")
            }
            className="bg-[#9e76b4]/20 w-full hover:bg-[#9e76b4]/60 rounded-lg cursor-pointer transition-all duration-500 group overflow-hidden shadow-lg"
          >
            <div className="flex flex-col justify-center items-center h-20 border-b-4 border-[#9e76b4] px-5 space-y-1">
              <span className="text-red-500 font-[600] md:text-2xl text-lg">
                ระบบสวัสดิการด้านสุขภาพ
              </span>
              <span className="text-[#9e76b4]  group-hover:text-white font-[600] md:text-2xl text-lg">
                ตรวจสอบสิทธิ/วงเงินคงเหลือ
              </span>
            </div>
          </div>
          <div
            onClick={() =>
              window.open(
                "/FLEX/flex1/manual-Flexible-Benefits-CMU_compressed.pdf",
                "_blank"
              )
            }
            className="bg-[#9e76b4]/20 w-full hover:bg-[#9e76b4]/60 rounded-lg cursor-pointer transition-all duration-500 group overflow-hidden shadow-lg"
          >
            <div className="flex flex-col justify-center items-center h-20 border-b-4 border-[#9e76b4] px-5 space-y-1">
              <span className="text-red-500 font-[600] md:text-2xl text-lg">
                คู่มือการใช้งานเบื้องต้น
              </span>
              <span className="text-[#9e76b4]  group-hover:text-white font-[600] md:text-2xl text-lg">
                Flexible Benefits CMU
              </span>
            </div>
          </div>
          <div
            onClick={() =>
              window.open("/FLEX/flex1/แบบ-เลือกสวัสดิการ-68.pdf", "_blank")
            }
            className="bg-[#9e76b4]/20 w-full hover:bg-[#9e76b4]/60 rounded-lg cursor-pointer transition-all duration-500 group overflow-hidden shadow-lg"
          >
            <div className="flex flex-col justify-center items-center h-20 border-b-4 border-[#9e76b4] px-5 space-y-1">
              <span className="text-red-500 font-[600] md:text-2xl text-lg">
                เแบบเลือกแผนสวัสดิการ
              </span>
              <span className="text-[#9e76b4]  group-hover:text-white font-[600] md:text-2xl text-lg">
                พนักงานมหาวิทยาลัยประจำ (บรรจุใหม่)
              </span>
            </div>
          </div>
        </div>
      </>
    );
  };

  // Youtube
  const menu_youtube = () => {
    const options = {
      margin: 10,
      responsiveClass: true,
      dots: false,
      autoplayHoverPause: true,
      navText: [
        '<span class="custom-nav-btn"><i class="fa-solid fa-backward"></i> </span>',
        '<span class="custom-nav-btn"> <i class="fa-solid fa-forward"></i></span>',
      ],

      responsive: {
        0: { items: 1, nav: true },
        600: { items: 2, nav: true },
        1000: { items: 3, nav: true },
        1200: { items: 3, nav: false },
      },
    };
    return (
      <>
        <ReactOwlCarousel className={`owl-theme`} {...options}>
          <Link
            to={"https://www.youtube.com/watch?v=TmQ7ecDLwEI"}
            target="_blank"
            className="flex items-center w-full me-auto group cursor-pointer hover:no-underline"
          >
            <div className="w-16 h-16 overflow-hidden">
              <img
                src="https://img.icons8.com/?size=100&id=Uu6z6IbXGn1K&format=png&color=000000"
                className="object-cover"
                alt=""
              />
            </div>
            <div className="flex flex-col justify-center items-center text-2xl font-bold group-hover:text-[#9e76b4] transition-all duration-300 text-gray-400">
              <span className="drop-shadow-sm">การเบิกสวัสดิการ</span>
            </div>
          </Link>
          <Link
            to={"https://www.youtube.com/watch?v=jnv_hcG5sM4"}
            target="_blank"
            className="flex items-center w-full me-auto group cursor-pointer hover:no-underline"
          >
            <div className="w-16 h-16 overflow-hidden">
              <img
                src="https://img.icons8.com/?size=100&id=Uu6z6IbXGn1K&format=png&color=000000"
                className="object-cover"
                alt=""
              />
            </div>
            <div className="flex flex-col justify-center items-center text-2xl font-bold group-hover:text-[#9e76b4] transition-all duration-300 text-gray-400">
              <span className="drop-shadow-sm">การดูแลแผนประกัน</span>
            </div>
          </Link>

          <Link
            to={"https://www.youtube.com/watch?v=G6HKTlLE6a8"}
            target="_blank"
            className="flex items-center w-full me-auto group cursor-pointer hover:no-underline"
          >
            <div className="w-16 h-16 overflow-hidden">
              <img
                src="https://img.icons8.com/?size=100&id=Uu6z6IbXGn1K&format=png&color=000000"
                className="object-cover"
                alt=""
              />
            </div>
            <div className="flex flex-col justify-center items-center text-2xl font-bold group-hover:text-[#9e76b4] transition-all duration-300 text-gray-400">
              <span className="drop-shadow-sm">
                {" "}
                <span className="text-red-500">กรณี</span> ถูกตีกลับ จาก Admin
              </span>
            </div>
          </Link>
        </ReactOwlCarousel>
      </>
    );
  };

  // ด้านสุขภาพ
  const menu_health = () => {
    const datadetail = [
      {
        id: 1,
        link: "/FLEX/detail-flex/01.jpg",
        img: "/FLEX/detail-flex/01.jpg",
        title: "การรักษาพยาบาล หรือ การยริการทางการแพทย์",
      },
      {
        id: 2,
        link: "/FLEX/detail-flex/02.jpg",
        img: "/FLEX/detail-flex/02.jpg",
        title: "การตรวจสุขภาพ หรือ การตรวจร่างกาย",
      },
      {
        id: 3,
        link: "/FLEX/detail-flex/03.jpg",
        img: "/FLEX/detail-flex/03.jpg",
        title: "การทันตกรรม",
      },
      {
        id: 4,
        link: "/FLEX/detail-flex/04.jpg",
        img: "/FLEX/detail-flex/04.jpg",
        title: "การรักษาด้านสุขภาพจิต และ จิตเวช",
      },
      {
        id: 5,
        link: "/FLEX/detail-flex/05.jpg",
        img: "/FLEX/detail-flex/05.jpg",
        title: "การฉีดวัคซีน",
      },
      {
        id: 6,
        link: "/FLEX/detail-flex/06.jpg",
        img: "/FLEX/detail-flex/06.jpg",
        title: "กายภาพบำบัด หรือ รักษาด้วยสหสาขาวิชาทางการแพทย์",
      },
      {
        id: 7,
        link: "/FLEX/detail-flex/07.jpg",
        img: "/FLEX/detail-flex/07.jpg",
        title: "การรักษา หรือ การแก้ไขความผิดปกติของสายตา",
      },
    ];

    return (
      <>
        <Fancybox
          ortions={{
            Carousel: {
              infinite: false,
            },
          }}
        >
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4">
            {datadetail.map((item, index) => (
              <div
                data-fancybox={"gallery"}
                data-src={item.img}
                key={index}
                target="_blank"
                className="flex flex-col space-y-2 shadow-lg rounded-lg px-3 py-2 
            text-gray-600 cursor-pointer hover:shadow-xl hover:no-underline
            hover:text-[#9e76b4]  transition-all duration-300 "
              >
                <div>
                  <img src={item.img} className="object-cover" alt="" />
                </div>
                <span className="text-sm text-center">{item.title}</span>
              </div>
            ))}
          </div>
        </Fancybox>
      </>
    );
  };

  // ด้านเสริมสุขภาพ
  const menu_health2 = () => {
    const datadetail = [
      {
        id: 1,
        link: "/FLEX/detail-flex/02-01.jpg",
        img: "/FLEX/detail-flex/02-01.jpg",
        title: "การใช้บริการสถานที่ออกกำลังกาย",
      },
      {
        id: 2,
        link: "/FLEX/detail-flex/02-02.jpg",
        img: "/FLEX/detail-flex/02-02.jpg",
        title: "การสมัครแข่งขันกีฬา",
      },
    ];

    return (
      <>
        <Fancybox
          options={{
            Carousel: {
              infinite: false,
            },
          }}
        >
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4">
            {datadetail.map((item, index) => (
              <div
                data-fancybox="gallery"
                data-src={item.img}
                key={index}
                target="_blank"
                className="flex flex-col space-y-2 shadow-lg rounded-lg px-3 py-2 
            text-gray-600 cursor-pointer hover:shadow-xl hover:no-underline
            hover:text-[#9e76b4]  transition-all duration-300 "
              >
                <div>
                  <img src={item.img} className="object-cover" alt="" />
                </div>
                <span className="text-sm text-center">{item.title}</span>
              </div>
            ))}
          </div>
        </Fancybox>
      </>
    );
  };

  // ด้านบุคลิกภาพ
  const menu_personality = () => {
    const datadetail = [
      {
        id: 1,
        link: "/FLEX/detail-flex/03-01.jpg",
        img: "/FLEX/detail-flex/03-01.jpg",
        title: "การทำหัตถการ การดูแลรกษารูปร่าง",
      },
      {
        id: 2,
        link: "/FLEX/detail-flex/03-02.jpg",
        img: "/FLEX/detail-flex/03-02.jpg",
        title: "การสมัครแข่งขันกีฬา",
      },
    ];

    return (
      <>
        <Fancybox
          ortions={{
            Carousel: {
              infinite: false,
            },
          }}
        >
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4">
            {datadetail.map((item, index) => (
              <div
                data-fancybox={"gallery"}
                data-src={item.img}
                key={index}
                target="_blank"
                className="flex flex-col space-y-2 shadow-lg rounded-lg px-3 py-2 
            text-gray-600 cursor-pointer hover:shadow-xl hover:no-underline
            hover:text-[#9e76b4]  transition-all duration-300 "
              >
                <div>
                  <img src={item.img} className="object-cover" alt="" />
                </div>
                <span className="text-sm text-center">{item.title}</span>
              </div>
            ))}
          </div>
        </Fancybox>
      </>
    );
  };

  // ด้านอื่นๆ
  const menu_other = () => {
    const datadetail = [
      {
        id: 1,
        link: "/FLEX/detail-flex/04-01.jpg",
        img: "/FLEX/detail-flex/04-01.jpg",
        title: "การใช้บริการสปา หรือ การนวดแผนไทย",
      },
      {
        id: 2,
        link: "/FLEX/detail-flex/04-02.jpg",
        img: "/FLEX/detail-flex/04-02.jpg",
        title: "การสมัครเรียนกิจกรรมเสริม",
      },
      {
        id: 3,
        link: "/FLEX/detail-flex/04-03.jpg",
        img: "/FLEX/detail-flex/04-03.jpg",
        title: "ค่ายา ค่าอุปกรณ์การแพทย์",
      },
      {
        id: 4,
        link: "/FLEX/detail-flex/04-04.jpg",
        img: "/FLEX/detail-flex/04-04.jpg",
        title: "ค่าใช้จ่ายประกันสุขภาพกลุ่ม",
      },
      {
        id: 5,
        link: "/FLEX/detail-flex/04-05.jpg",
        img: "/FLEX/detail-flex/04-05.jpg",
        title: "อุปกรณ์ในการป้องกัน",
      },
    ];

    return (
      <>
        <Fancybox
          options={{
            Carousel: {
              infinite: false,
            },
          }}
        >
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4">
            {datadetail.map((item, index) => (
              <div
                data-fancybox={"gallery"}
                data-src={item.img}
                key={index}
                target="_blank"
                className="flex flex-col space-y-2 shadow-lg rounded-lg px-3 py-2 
            text-gray-600 cursor-pointer hover:shadow-xl hover:no-underline
            hover:text-[#9e76b4]  transition-all duration-300 "
              >
                <div>
                  <img src={item.img} className="object-cover" alt="" />
                </div>
                <span className="text-sm text-center">{item.title}</span>
              </div>
            ))}
          </div>
        </Fancybox>
      </>
    );
  };
  return (
    <>
      <Navbar />
      <div className="min-h-screen min-w-screen">
        <div className="container w-full md:max-w-5xl mx-auto my-5 md:my-10 flex flex-col justify-center gap-y-3 px-6 md:px-0">
          <div className="w-full flex items-center bg-gradient-to-bl from-[#9e76b4] to-[#5eafd2] h-full rounded-tl-3xl rounded-br-3xl">
            <div className="w-32 h-32 overflow-hidden">
              <img
                src="/logoHR.png"
                className="drop-shadow-md  transition duration-500 hover:scale-110"
                alt=""
              />
            </div>

            <div className="flex flex-col gap-y-2">
              <span className="text-gray-100 text-xl md:text-5xl font-bold drop-shadow-lg">
                BENEFITS : สวัสดิการด้านสุขภาพ
              </span>
              <span className="text-gray-100 text-lg md:text-xl font-semibold drop-shadow-md">
                สำหรับ: พนักงานมหาวิทยาลัย
              </span>
            </div>
          </div>

          {/* menu 1 */}
          {menu_one()}
          {/* menu 1 */}
          <hr className="border-[#9e76b4]/20 border-t-2" />
          {/* menu 2 youtude */}
          {menu_youtube()}
          {/* menu 2 youtude */}
          <hr className="border-[#9e76b4]/20 border-t-2" />

          <div className="w-full flex items-center bg-gradient-to-bl from-[#9e76b4] to-[#5eafd2] h-full rounded-tl-3xl rounded-br-3xl">
            <div className="w-20 h-20 overflow-hidden">
              <img
                src="/logoHR.png"
                className="drop-shadow-md  transition duration-500 hover:scale-110"
                alt=""
              />
            </div>
            <div className="flex flex-col gap-y-2">
              <span className="text-gray-100 text-2xl font-bold drop-shadow-lg">
                ด้านสุขภาพ: รายละเอียด
              </span>
            </div>
          </div>

          {menu_health()}

          <hr className="border-[#9e76b4]/20 border-t-2 " />
          <div className="w-full flex items-center bg-gradient-to-bl from-[#9e76b4] to-[#5eafd2] h-full rounded-tl-3xl rounded-br-3xl">
            <div className="w-20 h-20 overflow-hidden">
              <img
                src="/logoHR.png"
                className="drop-shadow-md  transition duration-500 hover:scale-110"
                alt=""
              />
            </div>
            <div className="flex flex-col gap-y-2">
              <span className="text-gray-100 text-2xl font-bold drop-shadow-lg">
                ด้านสร้างเสริมสุขภาพ: รายละเอียด
              </span>
            </div>
          </div>

          {menu_health2()}

          <hr className="border-[#9e76b4]/20 border-t-2 " />
          <div className="w-full flex items-center bg-gradient-to-bl from-[#9e76b4] to-[#5eafd2] h-full rounded-tl-3xl rounded-br-3xl">
            <div className="w-20 h-20 overflow-hidden">
              <img
                src="/logoHR.png"
                className="drop-shadow-md  transition duration-500 hover:scale-110"
                alt=""
              />
            </div>
            <div className="flex flex-col gap-y-2">
              <span className="text-gray-100 text-2xl font-bold drop-shadow-lg">
                ด้านสร้างเสริมบุคลิกภาพ: รายละเอียด
              </span>
            </div>
          </div>

          {menu_personality()}

          <hr className="border-[#9e76b4]/20 border-t-2 " />

          <div className="w-full flex items-center bg-gradient-to-bl from-[#9e76b4] to-[#5eafd2] h-full rounded-tl-3xl rounded-br-3xl">
            <div className="w-20 h-20 overflow-hidden">
              <img
                src="/logoHR.png"
                className="drop-shadow-md  transition duration-500 hover:scale-110"
                alt=""
              />
            </div>
            <div className="flex flex-col gap-y-2">
              <span className="text-gray-100 text-2xl font-bold drop-shadow-lg">
                ด้านอื่นๆ: รายละเอียด
              </span>
            </div>
          </div>

          {menu_other()}

          <hr className="border-[#9e76b4]/20 border-t-2 pb-20 " />
        </div>
      </div>
      <Footer />
    </>
  );
}
